import { useMutation } from 'react-admin';

const useImport = () => {
  return useMutation();
};

export default useImport;
